import { render, staticRenderFns } from "./DialogMoveToDir.vue?vue&type=template&id=2bc8f112&scoped=true"
import script from "./DialogMoveToDir.vue?vue&type=script&lang=js"
export * from "./DialogMoveToDir.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc8f112",
  null
  
)

export default component.exports